/**
 * Programmatic App Bridge Contextual Save Bar (React-controlled forms).
 * Pair with `useSaveBar(id, dirty)` - do not also put `data-save-bar` on the form.
 *
 * Buttons inside `ui-save-bar` are plain HTML with App Bridge `variant` attrs.
 */
export function SaveBarHost({
  id,
  onSave,
  onDiscard,
  saving,
}: {
  id: string;
  onSave: () => void;
  onDiscard: () => void;
  saving?: boolean;
}) {
  const saveProps = {
    type: "button" as const,
    variant: "primary",
    disabled: saving || undefined,
    onClick: () => onSave(),
  };
  const discardProps = {
    type: "button" as const,
    disabled: saving || undefined,
    onClick: () => onDiscard(),
  };

  return (
    <ui-save-bar id={id}>
      {/* App Bridge save-bar buttons accept `variant` beyond DOM ButtonHTMLAttributes */}
      <button {...(saveProps as React.ButtonHTMLAttributes<HTMLButtonElement>)}>
        Save
      </button>
      <button
        {...(discardProps as React.ButtonHTMLAttributes<HTMLButtonElement>)}
      >
        Discard
      </button>
    </ui-save-bar>
  );
}
